import { TimeTableContent } from "../../components/app";

export default function TimeTable() {
  return (
    <>
      <TimeTableContent />
    </>
  );
}
